var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7126 7L11 8.7625L16.5628 14.5L11 20.2375L12.7126 22L20 14.5L12.7126 7Z",
    fill: "#0088FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterBlue);
export default __webpack_public_path__ + "static/media/enter_blue.389d52cf62903f30045223d8f82872f2.svg";
export { ForwardRef as ReactComponent };